<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>
          <el-button class="search-btn" size="small" type="success" icon="el-icon-upload2" @click="handleExport">导出</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入企业名称" v-model="searchInfo.enterpriseName"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          prop="enterpriseName"
          label="企业名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="enterpriseCode"
          width="180"
          label="企业代码">
        </el-table-column>
        <el-table-column
          prop="parkName"
          label="地区/园区"
          width="150">
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="organizationNames"-->
        <!--label="诉求主要涉及单位"-->
        <!--width="150">-->
        <!--</el-table-column>-->
        <el-table-column
          prop="appealType"
          label="诉求类型"
          width="80"
          :formatter="appealTypeFormatter">
        </el-table-column>
        <el-table-column
          prop="appealContent"
          label="诉求事项"
          :formatter="contentFormatter"
          width="180">
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="100"
                         :formatter="statusFortmatter">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="100">
        </el-table-column>
        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button type="success" size="mini" icon="el-icon-view" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
            <el-button v-if="scope.row.status === 'finish' && scope.row.opinionFile" @click="downloadOpinion(scope.row.opinionFile)" size="mini" type="main">满意度调查表</el-button>
            <!--<el-button v-if="user.role==='admin'" type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog title="详情" width="75%" :visible.sync="handleDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDetailInfo" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input v-model="handleDetailInfo.enterpriseName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
              <el-input v-model="handleDetailInfo.enterpriseCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：" prop="legalPerson">
              <el-input v-model="handleDetailInfo.legalPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="contactPerson">
              <el-input v-model="handleDetailInfo.contactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contact">
              <el-input v-model="handleDetailInfo.contact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人身份证：" prop="contactIdCard">
              <el-input v-model="handleDetailInfo.contactIdCard" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在园区：" prop="parkName">
              <el-input v-model="handleDetailInfo.parkName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：" prop="appealType">
              <el-select v-model="handleDetailInfo.appealType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诉求事项说明：" prop="appealContent">
              <el-input v-model="handleDetailInfo.appealContent" type="textarea" :rows="6" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="相关附件：">
              <div v-for="file in appealFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="handleDetailInfo" style="border-top: 1px solid #888888;padding-top: 15px;" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="第一环节处理人：">
              <el-input v-model="handleDetailInfo.firstName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第一环节处理时间：">
              <el-input v-model="handleDetailInfo.deliveryTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="第一环节处理意见：">
              <el-input v-model="handleDetailInfo.deliveryComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理单位：" prop="organizationNames">
              <el-input v-model="handleDetailInfo.organizationNames.toString()" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="第二环节处理人：">
              <el-input v-model="handleDetailInfo.secondName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第二环节处理时间：">
              <el-input v-model="handleDetailInfo.handleTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="第二环节处理意见：">
              <el-input v-model="handleDetailInfo.handleComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDetailInfoVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="筛选" width="75%" :visible.sync="searchDialogVisible" :close-on-click-modal="false">
      <el-form :model="searchInfo" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：">
              <el-input v-model="searchInfo.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码：">
              <el-input v-model="searchInfo.enterpriseCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：">
              <el-input v-model="searchInfo.legalPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：">
              <el-input v-model="searchInfo.contactPerson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <el-input v-model="searchInfo.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证：">
              <el-input v-model="searchInfo.contactIdCard"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地区/园区：">
              <el-select
                style="width: 100%"
                v-model="searchInfo.park"
                filterable
                placeholder="请输入地区/园区" clearable>
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：">
              <el-select v-model="searchInfo.appealType" placeholder="请选择" style="width:100%" clearable>
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSearch">搜 索</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { enterpriseAppealList, enterpriseAppeaExport, enterpriseAppealDelete, enterpriseAppealFile, portalDictionary,portalParkList, listOrg, listOrgUser, detailUser} from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user,
        parkList: [],
        organizationList: [],
        userList: [],
        appealFile: [],
        handleStatusDic: [{
          code: 'unhandle',
          name: '不处理'
        },{
          code: 'finish',
          name: '已完成'
        }],
        handleDetailInfo: {
          appealIds: [],
          firstName: '',
          secondName: '',
          organizationNames: ''
        },
        appealTypeList: [],
        handleDetailInfoVisible: false
      }
    },
    mounted () {
      portalDictionary('appeal_type').then(res => {
        if (res.data.code === 0) {
          this.appealTypeList = res.data.data
        }
      })
      listOrg(1, 99999).then(res => {
        if(res.data.code === 0){
          this.organizationList = res.data.data.list
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      downloadOpinion (url) {
        window.open(url)
      },
      getOrgName (orgId) {
        let name = ''
        this.organizationList.some(org => {
          if (org.id === orgId) {
            name = org.name
            return true
          }
        })
        return name
      },
      handleOrgChange (val) {
        listOrgUser({
          orgIds: val
        }).then(res => {
          if (res.data.code === 0) {
            this.userList = []
            res.data.data.forEach(ug => {
              this.userList.push({
                label: this.getOrgName(ug.orgId),
                orgId: ug.orgId,
                options: ug.userInfos
              })
            })
          }
        })
      },
      handleDelete (col, row) {
        this.$confirm('确认要删除该记录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          enterpriseAppealDelete(row.id).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.searchList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
      },
      handleExport () {
        this.searchInfo.infoType='opinion'
        enterpriseAppeaExport(this.searchInfo).then(res => {
          const blob = new Blob([res.data])
          const fileName = '诉求意见.xlsx'
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        })
      },
      handleDetail (col, row) {
        this.handleDetailInfo = Object.assign({firstName:'',secondName:''}, row)
        this.appealFile = []
        enterpriseAppealFile(row.id).then(res => {
          if (res.data.code === 0) {
            this.appealFile = res.data.data
          }
        })
        detailUser(this.handleDetailInfo.deliveryUser).then(res => {
          if (res.data.code === 0) {
            this.handleDetailInfo.firstName = res.data.data.name + '(' + res.data.data.organization + ')'
          }
        })
        detailUser(this.handleDetailInfo.handleUser).then(res => {
          if (res.data.code === 0) {
            this.handleDetailInfo.secondName = res.data.data.name + '(' + res.data.data.organization + ')'
          }
        })
        this.handleDetailInfoVisible = true
      },
      searchMethod () {
        this.searchInfo.status = ''
        this.searchInfo.infoType='opinion'
        return enterpriseAppealList(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      addMethod () {
      },
      beforeUpdate () {
      },
      updateMethod () {
      },
      statusFortmatter (row, col) {
        let name = ''
        if (row.status === 'unhandle') {
          name = '不处理'
        }else if (row.status === 'finish'){
          name = '已完成'
        }
        if (row.status === 'distribution') {
          name = '已分配'
        }
        if (row.status === 'wait') {
          name = '待处理'
        }
        if (row.status === 'withdraw') {
          name = '退回'
        }
        return name
      },
      contentFormatter (row, col) {
        return row.appealContent.substring(0,10) + (row.appealContent.length<10?'':'...')
      },
      appealTypeFormatter (row, col) {
        let name = ''
        this.appealTypeList.forEach(a => {
          if (a.code === row.appealType) {
            name = a.name
          }
        })
        return name
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
</style>



// WEBPACK FOOTER //
// src/components/EnterpriseAppealHistory.vue